import { Feedback } from "@/requests/questionnaries/responses-by-quiz-id.request";
import { FC } from "react";

type EvaluationFeedbackProps = {
  feedback: Feedback;
};

const EvaluationFeedback: FC<EvaluationFeedbackProps> = ({ feedback }) => {
  const hasContent = [
    feedback.recommendations.recommendations,
    feedback.bestPractices.bestPractices,
    feedback.tools,
    feedback.benchmarkAndReferences,
  ].some((str) => str && str.trim() !== "");

  return (
    <>
      <h4 className="text-sm font-bold text-[#293038]">Feedback</h4>

      {hasContent ? (
        <>
          {feedback.recommendations.recommendations && (
            <div className="flex flex-col gap-2 text-sm">
              <div className="font-bold text-[#615CB7]">Recomendaciones</div>

              <div>{feedback.recommendations.recommendations}</div>
            </div>
          )}

          {feedback.bestPractices.bestPractices && (
            <div className="flex flex-col gap-2 text-sm">
              <div className="font-bold text-[#615CB7]">
                Prácticas recomendadas
              </div>

              <div>{feedback.bestPractices.bestPractices}</div>
            </div>
          )}

          {feedback.tools && (
            <div className="flex flex-col gap-2 text-sm">
              <div className="font-bold text-[#615CB7]">Herramientas</div>

              <div>{feedback.tools}</div>
            </div>
          )}

          {feedback.benchmarkAndReferences && (
            <div className="flex flex-col gap-2 text-sm">
              <div className="font-bold text-[#615CB7]">
                Benchmark y referencias
              </div>

              <div>{feedback.benchmarkAndReferences}</div>
            </div>
          )}
        </>
      ) : (
        <div className="text-sm text-muted-foreground">
          No hay feedback disponible.
        </div>
      )}
    </>
  );
};

export default EvaluationFeedback;
